import React, { Children, useEffect, useRef, useState } from "react";
import slidersIcon from '../../assests/ui/sliders.png';
import classes from './Filter.module.css';
import PropTypes, { array, instanceOf } from 'prop-types';
import { useSelector } from "react-redux";
import selectArrowIcon from '../../assests/ui/select-arrow.png';
import useClickOutside from "../../hooks/useClickOutside";
import { onKeyDown } from "../../service";


/**
    * get list as props
    * and 2 children:
    * first Filters with array of Filter children
    * second FilterItem with 1 children that FilterExtention pass into it param named filteredlist that contain the filtered list
    * according to conditions in Filters array 
    */
const FilterExtention = ({ children, list, filterHeight, filterWidth, setFilteredListOutput }) => {
    const [filteredlist, setFilteredList] = useState(list);

    validateFilterExtentionChildrenTree(children);

    return (<>
        <Filters filterHeight={filterHeight} filterWidth={filterWidth} list={list} setFilteredList={setFilteredList} setFilteredListOutput={setFilteredListOutput}>{children[0].props.children}</Filters>
        <FilterItem filteredlist={filteredlist}>
            {children[1].props.children}
        </FilterItem>
    </>)
}
FilterExtention.propsTypes = {
    stateOfList: PropTypes.array,
    setStateOfList: PropTypes.func
}

const Filters = React.memo(({ children, list, setFilteredList, filterHeight, filterWidth, setFilteredListOutput }) => {
    const [showFilterPopup, setShowFilterPopup] = useState(false);
    const [filtersInputs, setFilterInputs] = useState(children instanceof Array ?
        children.reduce((inputs, filter) => {
            inputs[filter.props.name] = '';
            return inputs
        }, {}) :
        { [children.props.name]: '' }
    );

    // console.log("Filters RUNNING");

    useEffect(() => {
        const filteredlist = list && list.filter(x =>
            Object.keys(filtersInputs).map(key => {
                if (key === "free") {
                    if (!filtersInputs[key].toString() || (filtersInputs[key] && Object.keys(x).some(field => x[field] && x[field].includes && x[field].includes(filtersInputs[key].toString()))))
                        return true;
                    else
                        return false
                }
                else {
                    if (!filtersInputs[key] ||
                        (filtersInputs[key] && filtersInputs[key].toString() && (x[key] || x[key] === false) && x[key].toString().includes(filtersInputs[key].toString()))
                        || ((Array.isArray(x[key])) && (filtersInputs[key] >= x[key][0] && filtersInputs[key] <= x[key][1]))
                    ) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }).every(x => x === true)
        );
        setFilteredListOutput && setFilteredListOutput(filteredlist)
        setFilteredList(filteredlist)
    }, [filtersInputs, list, setFilteredList])

    const handleChangeInputs = (event) => {
        setFilterInputs(prevFilterInputs => {
            const newFilterInputs = { ...prevFilterInputs }
            newFilterInputs[event.target.name] = event.target.value;
            return newFilterInputs;
        });
    }

    const handleChangeButtonsInputs = (name, value) => {
        setFilterInputs(prevFilterInputs => {
            const newFilterInputs = { ...prevFilterInputs }
            newFilterInputs[name] = value;
            return newFilterInputs;
        });
    }
    return <div className={classes.Filter} style={{ height: `${filterHeight}`, width: `${filterWidth}` }}>
        {Children.toArray(children).map(filter => filter.props.name == 'free' && <Filter key={filter.props.name} {...filter.props} handleChange={handleChangeInputs} handleChangeButtonsInputs={handleChangeButtonsInputs} value={filtersInputs[filter.props.name]} list={list}></Filter>)}
        <div className={classes.FilterResponsiveContainer}>
            <div className={`${classes.FilterResponsive} ${showFilterPopup ? classes.FilterResponsiveShow : ''}`}>
                <img src={slidersIcon} alt="SliderIcon" onClick={() => setShowFilterPopup(prev => !prev)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowFilterPopup(prev => !prev))} />
                {Children.toArray(children).map(filter => filter.props.name !== 'free' && <Filter key={filter.props.name} {...filter.props} handleChange={handleChangeInputs} handleChangeButtonsInputs={handleChangeButtonsInputs} value={filtersInputs[filter.props.name]} list={list}></Filter>)}
            </div>
        </div>
    </div >
})
Filters.propsTypes = {
    list: PropTypes.array,
    setFilteredList: PropTypes.func
}

const FilterTypesEnum = {
    free: 1,
    values: 2,
    buttons: 3,
    bool: 4,
    valuesList: 5
}

const Filter = ({ name, text, type, handleChange, value, list, handleChangeButtonsInputs, values }) => {
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction)
    const [showSelect, setShowSelect] = useState(false);
    const [filterBy, setFilterBy] = useState(texts.all);
    // const valuesObj = values && {...values};

    const handleSelect = value => {
        handleChange({ target: { name, value: value === texts.all ? "" : value } })
        setFilterBy(value);
        setShowSelect(false);
    }

    const selectRef = useRef(null);

    useClickOutside(selectRef, () =>
        setShowSelect(false)
    );

    const handleChangeSelect = e => {
        e.stopPropagation();
        setShowSelect(showSelect => !showSelect);
    }

    switch (type) {
        case FilterTypesEnum.free:
            return (<div key={name} className={classes.WrapInput}>
                <input type='text' placeholder={text} name="free" className={classes.Input} onChange={handleChange} ></input>
                <div className={classes.FilterIcon}></div>
            </div>)
        case FilterTypesEnum.values:
            return (<div key={name} className={`${classes.WrapInput} ${classes[direction]}`}>
                <label className={classes.Label}>{text}</label>
                <div className={classes.SelectContainer}>
                    <div className={classes.SelectWrapper}>
                        <div className={classes.SelectSelected} onClick={handleChangeSelect} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, handleChangeSelect)}>
                            <div>{filterBy}</div>
                            <img src={selectArrowIcon} alt="SelectArrow" className={showSelect ? classes.SelectArrowIconOpen : classes.SelectArrowIconClose} />
                        </div>
                        {showSelect && <div ref={selectRef} className={classes.SelectDropDown}>
                            {list && [texts.all, ...[...new Set(list.flatMap(x => x[name] ? [x[name]] : []))].sort((a, b) => a.localeCompare(b))].map(item => <div key={item} className={`${classes.Option} ${filterBy === item ? classes.SelectedOption : ''}`} onClick={() => handleSelect(item)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleSelect(item))}>{item}</div>)}
                        </div>}
                    </div>
                </div>
            </div>)
        case FilterTypesEnum.buttons:
            // onClick={() => setShowImageUploadPopup(true)}
            return (
                <div>
                    <div className={classes.TextContainer}>
                        <div>{text}</div>
                        <div className={classes.Clear} onClick={() => handleChangeButtonsInputs(name, null)}>{texts.clear}</div>
                    </div>

                    <div className={classes.ButtonsWarrper}>
                        {list && [...new Set(list.map(item => item[name]))].map(item =>
                            <div className={`${classes.Button}  ${value == item ? classes.SelectedButton : ''}`} key={item} onClick={() => handleChangeButtonsInputs(name, item)}>{`${item}`}</div>
                            // <div></div>
                        )}

                    </div>
                </div>
            )

        case FilterTypesEnum.valuesList:
            const valuesObj = { [texts.all]: texts.all, ...values };
            return (<div key={name} className={`${classes.WrapInput} ${classes[direction]}`}>
                <label className={classes.Label}>{text}</label>
                <div className={classes.SelectContainer}>
                    <div className={classes.SelectWrapper}>
                        <div className={classes.SelectSelected} onClick={handleChangeSelect} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, handleChangeSelect)}>
                            <div>{values[filterBy] ?? texts.all}</div>
                            <img src={selectArrowIcon} alt="SelectArrow" className={showSelect ? classes.SelectArrowIconOpen : classes.SelectArrowIconClose} />
                        </div>
                        {showSelect && <div ref={selectRef} className={classes.SelectDropDown}>
                            {list && [...Object.keys(valuesObj).map(value => <div key={value} className={`${classes.Option} ${filterBy === value ? classes.SelectedOption : ''}`} onClick={() => handleSelect(value)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleSelect(value))}>{valuesObj[value]}</div>)]}
                        </div>}
                    </div>
                </div>
            </div>)

        // case FilterTypesEnum.bool:
        //     return (<div key={name} className={`${classes.WrapInput} ${classes[direction]}`}>
        //         <label className={classes.Label}>{text}</label>
        //         <div className={classes.SelectContainer}>
        //             <div className={classes.SelectWrapper}>
        //                 <div className={classes.SelectSelected} onClick={handleChangeSelect} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, handleChangeSelect)}>
        //                     <div>{filterBy}</div>
        //                     <img src={selectArrowIcon} alt="SelectArrow" className={showSelect ? classes.SelectArrowIconOpen : classes.SelectArrowIconClose} />
        //                 </div>
        //                 {showSelect && <div ref={selectRef} className={classes.SelectDropDown}>
        //                     {list && [texts.all, ...[{ text: texts.active, value: true }, { text: texts.noActive, value: false }]].map(item => <div key={item.text} className={`${classes.Option} ${filterBy === item.value ? classes.SelectedOption : ''}`} onClick={() => handleSelect(item.value)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleSelect(item.value))}>{item.text}</div>)}

        //                 </div>}
        //             </div>
        //         </div>
        //     </div>)
        default:
            return null
    }
}
Filter.propsTypes = {
    name: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.oneOf([FilterTypesEnum.free, FilterTypesEnum.values]),
}

const FilterItem = ({ children, filteredlist }) => {

    return React.cloneElement(children, {
        filteredlist: filteredlist
    })
}
FilterItem.propsTypes = {
    children: PropTypes.node,
    filteredlist: PropTypes.array
}

const validateFilterExtentionChildrenTree = (children) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        let error;
        if (children instanceof Array) {
            if (children.length > 2)
                error = "Filter expect exactly 2 children Filters and FilterItem"
            else if (children[0].type !== Filters)
                error = "Filter first child must be instace of Filters"
            else {
                if (children[1].type !== FilterItem)
                    error = "Filter second child must be instace of FilterItem";
                if (((children[0].props.children instanceof Array && children[0].props.children.some(f => f.type !== Filter)) || (!(children[0].props.children instanceof Array) && children[0].props.children.type !== Filter)))
                    error = "Filters has children that aren't Filter component";
                if (children[1].props.children instanceof Array)
                    error = "FilterItem expect exactly 1 children";
            }
        } else {
            error = "Filter expect exactly 2 children Filters and FilterItem";
        }
        if (error)
            throw new Error(`${error} note that there are no unnecessary spaces`);
    }
}


export { FilterExtention, FilterTypesEnum, FilterItem, Filter, Filters };